import { Trans } from '@lingui/react'
import { bool, func, shape, string } from 'prop-types'

import noop from 'shared/utils/noop'
import Button from 'views/components/atoms/Button'
import Form from 'views/components/atoms/Form'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import IconProfile from 'views/components/atoms/Icon/IconProfile'
import OffCanvasNewList from 'views/components/organisms/OffCanvasNew/OffCanvasNewList'
import OffCanvasNewScreen from 'views/components/organisms/OffCanvasNew/OffCanvasNewScreen'
import withMountPoints from 'views/enhancers/withMountPoints'
import { mountPointsType } from 'views/utils/propTypes'

const OffCanvasNewHomeView = ({
  data,
  closeMenuHandler,
  userData,
  onShowStaticPage,
  mountPoints,
  dataQaId,
}) => {
  const headerText = user => {
    if (user?.isLoggedIn) {
      return (
        <>
          <IconProfile />
          <div>
            <Button
              className="o-OffCanvasNewView__header-link"
              href={mountPoints.getUserAccount()}
              data-qa-id="m-account-menu"
            >
              <Trans id="offcanvas.link.myApotheke" />
            </Button>
          </div>
        </>
      )
    }

    return (
      <>
        <IconProfile />
        <div>
          <Button
            data-qa-id="m-login-menu"
            className="o-OffCanvasNewView__header-link"
            href={mountPoints.getLogin()}
          >
            <Trans id="general.label.loginOrRegister" />
          </Button>
        </div>
      </>
    )
  }

  const renderLogout = (user, mountPoints) => {
    if (user?.isLoggedIn) {
      return (
        <li>
          <Form
            name="offcanvas-logout-form"
            method="POST"
            action={mountPoints.getLogout()}
          >
            <Button
              isReactControlled
              style="buttonGhost"
              type="submit"
              className="o-OffCanvasNew__list-item o-OffCanvasNew__list-item--transparent-background"
              data-qa-id="m-logount-button"
            >
              <Trans id="offcanvas.link.logout" />
              <IconCaretRight className="u-margin-auto--left u-color--blue" />
            </Button>
          </Form>
        </li>
      )
    }

    return null
  }

  return (
    <OffCanvasNewScreen
      onMenuClose={closeMenuHandler}
      headerInfo={headerText(userData)}
      style={data.style}
    >
      <OffCanvasNewList
        dataQaId={dataQaId}
        items={data.categories.subCategories}
        onItemSelect={onShowStaticPage}
      >
        {renderLogout(userData, mountPoints)}
      </OffCanvasNewList>
    </OffCanvasNewScreen>
  )
}

OffCanvasNewHomeView.propTypes = {
  userData: shape({}),
  hidden: bool,
  goBackHandler: func,
  closeMenuHandler: func,
  onShowStaticPage: func,
  data: shape({}),
  mountPoints: mountPointsType,
  dataQaId: string,
}

OffCanvasNewHomeView.defaultProps = {
  userData: null,
  hidden: false,
  goBackHandler: noop,
  closeMenuHandler: noop,
  goNextHandler: () => noop,
  onShowStaticPage: noop,
}

export default withMountPoints(OffCanvasNewHomeView)
